import { render } from "./GetProductLotDetails.vue?vue&type=template&id=22f44d93"
import script from "./GetProductLotDetails.vue?vue&type=script&lang=js"
export * from "./GetProductLotDetails.vue?vue&type=script&lang=js"
script.render = render

export default script